var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25.522,
  height: 25.522,
  viewBox: "0 0 25.522 25.522"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.3,8.121H9.832V.844A.843.843,0,0,0,8.988,0h0a.843.843,0,0,0-.844.844V8.121H.844A.843.843,0,0,0,0,8.965H0a.843.843,0,0,0,.844.844h7.3v7.3a.843.843,0,0,0,.844.844h0a.843.843,0,0,0,.844-.844v-7.3H17.3a.843.843,0,0,0,.844-.844h0A.843.843,0,0,0,17.3,8.121Z",
  transform: "translate(12.695 0) rotate(45)"
})));
export default __webpack_public_path__ + "static/media/close.18b38fe7.svg";
export { SvgComponent as ReactComponent };